import { LegendBorderStyleTypes } from "@enums/legend-border-style";
import { ABANDONED_COLOR, APPROVED_COLOR, COMPLETE_APPROVED_COLOR, COMPLETE_COLOR, COMPLETE_DENIED_COLOR, DENIED_COLOR, INCOMPLETE_COLOR, PROCEED_FAIL_COLOR, PROCEED_PASS_COLOR } from "./colors";
import { resources } from "./hardcoded-strings";

export const WORKFLOW_STEP_BY_STEP_COMPLETE_APPROVED = "% Complete - Approved transactions by step";
export const WORKFLOW_STEP_BY_STEP_COMPLETE_DENIED = "% Complete - Denied transactions by step";
export const WORKFLOW_STEP_BY_STEP_ABANDONED = "% Abandoned transactions by step";


export const WORKFLOW_STEP_BY_STEP_PROCEED_PASS = "% Proceed - Pass transactions by step";
export const WORKFLOW_STEP_BY_STEP_PROCEED_FAIL = "% Proceed - Fail transactions by step";



export const WORKFLOW_STEP_BY_STEP_LEGEND_ITEMS = [
    { color: COMPLETE_APPROVED_COLOR, label:WORKFLOW_STEP_BY_STEP_COMPLETE_APPROVED, borderStyle: LegendBorderStyleTypes.ROUND },
    { color: COMPLETE_DENIED_COLOR, label: WORKFLOW_STEP_BY_STEP_COMPLETE_DENIED, borderStyle: LegendBorderStyleTypes.ROUND },
    { color: PROCEED_PASS_COLOR, label: WORKFLOW_STEP_BY_STEP_PROCEED_PASS, borderStyle: LegendBorderStyleTypes.ROUND },
    { color: PROCEED_FAIL_COLOR, label: WORKFLOW_STEP_BY_STEP_PROCEED_FAIL, borderStyle: LegendBorderStyleTypes.ROUND },
    { color: ABANDONED_COLOR, label: WORKFLOW_STEP_BY_STEP_ABANDONED, borderStyle: LegendBorderStyleTypes.ROUND },
];

export const WORKFLOW_REPORT_COMPLETION_RATES_LEGEND_ITEMS = [
    { color: COMPLETE_COLOR, label: resources.charts.workflowReportCompletionRates.labels.complete, borderStyle: LegendBorderStyleTypes.ROUND },
    { color: INCOMPLETE_COLOR, label: resources.charts.workflowReportCompletionRates.labels.incomplete, borderStyle: LegendBorderStyleTypes.ROUND }
];

export const WORKFLOW_REPORT_PASS_RATES_LEGEND_ITEMS = [
    { color: DENIED_COLOR, label: "Denied Unique Users", borderStyle: LegendBorderStyleTypes.ROUND },
    { color: APPROVED_COLOR, label: "Approved Unique Users", borderStyle: LegendBorderStyleTypes.ROUND }
];




